import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import logo from "../assets/images/logo.png";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <nav className="site-nav">
      <div className="nav-container">
        <Link to="/" className="brand-lockup" onClick={closeMenu}>
          <img src={logo} alt="Brian Hodgers campaign logo" className="brand-logo" />
          <div className="brand-copy">
            <span className="brand-name">Brian Hodgers</span>
            <span className="brand-office">Florida House District 32</span>
          </div>
        </Link>

        <button
          className={`hamburger ${menuOpen ? "active" : ""}`}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((isOpen) => !isOpen)}
        >
          <span />
          <span />
          <span />
        </button>

        <ul className={menuOpen ? "open" : ""}>
          <li>
            <NavLink to="/" className={({ isActive }) => (isActive ? "active" : "")} onClick={closeMenu}>
              Home
            </NavLink>
          </li>
          <li>
            <NavLink to="/about" className={({ isActive }) => (isActive ? "active" : "")} onClick={closeMenu}>
              About
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/endorsements"
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={closeMenu}
            >
              Endorsements
            </NavLink>
          </li>
          <li>
            <NavLink to="/contact" className={({ isActive }) => (isActive ? "active" : "")} onClick={closeMenu}>
              Contact
            </NavLink>
          </li>
          <li>
            <a
              className="nav-donate"
              href="https://secure.anedot.com/brian-hodgers-campaign-f3acd9b2-bee5-41d0-8d27-4b6d9291fadf/donate"
              target="_blank"
              rel="noreferrer"
              onClick={closeMenu}
            >
              Donate
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
